// src/lib/contractAgencyRep.js — what the composer may say about who signs for the agency.
//
// Owner ruling 2026-09-12: an agent must not be able to change the agency's representative or
// type one in; an agent the admin has authorised may put THEMSELVES in place of the director.
// The decision is the server's (lib/agency_rep.js, migration 1076) — this is only the shape of
// what the client is allowed to send, kept pure so it can be tested without a browser.
//
// 🔑 THE CLIENT SENDS AN ID OR NOTHING. Sending a name for that role would be a request the
// server discards, and a discarded request looks to the agent exactly like an accepted one:
// they would read their own name in the box, press Save, and get a document signed by the
// director with no explanation. So the name is not sent at all.

// The signature fields for ONE party, ready to merge into its payload.
// `role` decides everything: the agency's representative is granted, every other company's
// representative is typed by the agent as before.
export function repPayload(p) {
  if (p?.role === 'agency') {
    // No name, no title — and the id only when one was chosen (absent = "the default", which is
    // what the server does with nothing).
    return { rep_name: '', rep_position: '', ...(p.rep_party_id ? { rep_party_id: p.rep_party_id } : {}) }
  }
  const company = p?.kind === 'company'
  return {
    rep_name: company ? String(p?.rep_name || '').trim() : '',
    rep_position: company ? String(p?.rep_position || '').trim() : '',
  }
}

// Which of the two signatures the card should show as chosen. `self` is present only when the
// server said this viewer holds the grant, so an ordinary agent can never be "on self".
export function agencyRepShown({ options, repPartyId }) {
  const self = options?.self || null
  const dflt = options?.default || null
  const onSelf = !!(self && repPartyId && repPartyId === self.party_id)
  return { onSelf, shown: onSelf ? self : dflt, canSwitch: !!self }
}
